import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";

import theme from "../../theme";

export const Breadcrumb = ({ items, active }) => {
  const history = useHistory();

  const handleClick = (e) => {
    history.push(e);
  };

  return (
    <Breadcrumbs className="mb-3" aria-label="breadcrumb">
      {items?.map((itm, index) => (
        <Typography
          key={index}
          fontSize={14}
          onClick={() => {
            handleClick(itm?.path);
          }}
          color={`${theme.palette.primary.darkYellow}`}
          className="poppins-font-family cursor-pointer"
        >
          {itm?.page}
        </Typography>
      ))}
      <Typography fontSize={14} color="#999" className="poppins-font-family">
        {active.page}
      </Typography>
    </Breadcrumbs>
  );
};

Breadcrumb.prototype = {
  items: PropTypes.array,
  active: PropTypes.object,
};
